module.exports = __webpack_public_path__ + "74bce3c91b59104ea92a0ab0460b6330.svg";